import HeaderSubMenu from './submenu/HeaderSubMenu';
import React from 'react';
import Tippy from '@tippyjs/react/headless';
import GuestSignInLogo from './GuestSignInLogo';
import useUserDataStore from '../../store/userDataStore';

const ProfileMenu = () => {
  const userData = useUserDataStore((state) => state.userData);
  const profileImage = userData.image || 'default-profile-pic.png';

  return (
    <Tippy
      interactive={true}
      trigger='click'
      placement='bottom-end'
      render={(attrs) => (
        <div className='box' tabIndex='-1' {...attrs}>
          <HeaderSubMenu profileImage={profileImage} />
        </div>
      )}>
      <div className='profile-menu'>
        {profileImage && profileImage !== 'default-profile-pic.png' ? (
          <img
            className='user-profile-pic'
            src={profileImage}
            alt='User profile pic'
          />
        ) : (
          <GuestSignInLogo fillColor={'var(--bg-skyblue)'} />
        )}
      </div>
    </Tippy>
  );
};

export default ProfileMenu;
